import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { exams } from "../../../../../../api/exams";
import { useTranslation } from 'react-i18next';

function UnlockAssessmentModal({ closeModal, getExamsMutation, id, refetch, redirect }) {
  const { t } = useTranslation();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const examId = JSON.parse(sessionStorage.getItem('active-exam'))?.exam_id
  const userExamId = JSON.parse(sessionStorage.getItem('active-exam'))?.user_exam_id
  const navigate = useNavigate();
  const [values, setValues] = useState({
    otp: "",
    venue_code: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };
  const handleUnlockAssessment = async (e) => {
    e.preventDefault();
    let payload = {
      otp: values.otp,
      user_exam_id:  userExamId,
      venue_code: parseInt(values.venue_code),
    };

    try {
      toast.loading(t('loading'));
      const res = await exams.unlockAssessmentv2(user?.user?.user_id, examId, payload);
      toast.remove();
      toast.success(res.message);
      const activeExam = JSON.parse(sessionStorage.getItem('active-assessment'))
      if(!Boolean(activeExam?.redirect_to_speed_exam )){
        navigate("/candidate/assessments/instructions");
      }
      else window.location.href = "https://candidate.speedexam.net/signin.aspx?site=setassessment";
      refetch();
      closeModal(false);
    } catch (error) {
      toast.remove();
      if(error?.response?.data?.message){
        toast.error(error?.response?.data?.message);
      }
      else toast.error(error?.response?.data?.error); 
    }
  };

  return (
    <div className="fixed top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50 p-10 ">
      <div className="">
        <div className="min-h-[12rem] md:w-[600px] bg-white rounded-[32px] flex flex-col justify-center p-6 md:p-16 relative">
          <h3 className="flex justify-start text-lg leading-6 font-medium text-gray-900 mb-4">
            {t('unlock-assessment')}
          </h3>
          {/* {getExamsMutation.isLoading && <ScaleLoader_ />} */}
          <form onSubmit={handleUnlockAssessment}>
            <div className="mb-4">
              <label
                htmlFor="otp"
                className="flex justify-start mb-5 text-lightGrey text-base"
              >
                {t('otp')}
              </label>
              <input
                value={values.otp}
                onChange={handleInputChange}
                type="text"
                id="otp"
                className=" rounded-lg border-transparent flex-1 appearance-none border border-lightGrey w-full py-4 px-4 bg-customGrey text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-lightGrey focus:border-transparent"
                name="otp"
                placeholder={t('one-time-password')}
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="venue_code"
                className="flex justify-start mb-5 text-lightGrey text-base"
              >
                {t('venue-code')}
              </label>
              <input
                value={values.venue_code}
                onChange={handleInputChange}
                type="text"
                id="venue_code"
                className=" rounded-lg border-transparent flex-1 appearance-none border border-lightGrey w-full py-4 px-4 bg-customGrey text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-lightGrey focus:border-transparent"
                name="venue_code"
                placeholder={t('venue-code')}
              />
            </div>

            <div className="flex  justify-center gap-x-10">
              <button
                type="button"
                className="inline-flex justify-center rounded-md border border-darkBlue  shadow-sm px-8 py-2 md:px-16 md:py-4 bg-white text-sm font-medium text-darkBlue  sm:ml-3 sm:w-auto sm:text-sm mb-4 sm:mb-0"
                onClick={() => closeModal(false)}
              >
                {t('cancel')}
              </button>

              <button
                type="submit"
                className="inline-flex justify-center rounded-md border border-darkBlue  shadow-sm px-8 py-2 md:px-16 md:py-4 bg-darkBlue text-sm font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mb-4 sm:mb-0"
              >
                {t('apply')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UnlockAssessmentModal;
